class PasswordMeterElements {
    private readonly $documentObject: Document;
    private readonly meter: HTMLDivElement;

    constructor(document: Document) {
        this.$documentObject = document;
        this.meter = document.querySelector(".js_passwordStrengthMeter")! as HTMLDivElement;
    }

    showStrengthMeter() {
        this.meter.classList.remove("invisible");
    }

    hideStrengthMeter() {
        this.meter.classList.add("invisible");
    }

    toggleMeterColorAndLabel(strength: string) {
        const meterParts = this.getMeterPartElements();
        for (let i = 0; meterParts[i]; i++) {
            const element = meterParts[i];
            element.classList.remove("invalid", "weak", "okay", "strong");
            element.classList.add(strength.toLowerCase());
        }

        this.showOrHideStrengthLabels(strength);
    }

    private showOrHideStrengthLabels(strength: string) {
        const textLabels = this.getMeterTextLabelElements();
        const strengthClass = strength.toLowerCase();
        for (let i = 0; textLabels[i]; i++) {
            const element = textLabels[i];
            if (element.classList.contains(strengthClass)) {
                element.classList.remove("invisible");
            } else {
                element.classList.add("invisible");
            }
        }
    }

    resetMeterColorsAndText(initialStrength: string) {
        const meterParts = this.getMeterPartElements();
        for (let i = 0; meterParts[i]; i++) {
            const element = meterParts[i];
            element.classList.remove("weak", "okay", "strong");
            element.classList.add("invalid");
        }

        const textLabels = this.getMeterTextLabelElements();
        for (let i = 0; textLabels[i]; i++) {
            const element = textLabels[i];
            if (element.classList.contains(initialStrength.toLowerCase())) {
                element.classList.add("invisible");
            }
        }
    }

    private getMeterPartElements() {
        return this.$documentObject.querySelectorAll(".meter-part");
    }

    private getMeterTextLabelElements() {
        return this.$documentObject.querySelectorAll(".meter-text");
    }
}

export default PasswordMeterElements;
